<template>
    <div class="w-lg-500px bg-white rounded shadow-sm mt-0 p-10 p-15 mx-auto text-center">
        <div v-if="tokenVerified == false">
            <div class="text-center mb-10">
                <h1 class="text-primary mb-7">{{ $t('pages.contactVerify.email.failed.title') }}</h1>

                <div class="text-gray-600 fw-bold fs-7">
                    {{ $t('pages.contactVerify.email.failed.description') }}
                </div>
            </div>
            <div class="d-flex flex-wrap justify-content-center pb-0">
                <router-link to="/" class="btn btn-lg btn-primary fw-bolder">
                    {{ $t("pages.contactVerify.email.failed.backVerifyPage") }}
                </router-link>
            </div>
        </div>
        <div v-else>
            <h1 class="text-primary mb-10">{{ $t('pages.contactVerify.email.title') }}</h1>
            <div class="mb-6 pt-7">
                <span class="custom-spinner spinner-border spinner-border-sm align-middle"></span>
            </div>
            <div class="text-gray-600 fw-bold fs-4">
                {{ $t("messages.wait") }}
            </div>
        </div>
    </div>
</template>
<route>
{
    "meta": {
        "without_middleware": ["contact_verify"]
    }
}
</route>
<script>
export default {
    layout: 'contact-verify',
    name: "_token",
    data() {
        return {
            form: {
                data: {}
            },
            tokenVerified: undefined,
        }
    },
    computed: {
        currentUser(){
            return this.$store.getters.currentUser;
        },
        token() {
            return this.$route.params.token;
        },
    },
    created() {
        if (this.token && ((typeof this.token !== 'string') || !(this.token.trim().length > 0))) {
            this.$router.push({
                path: "/"
            });
        }
    },
    mounted() {
        if (this.token && (typeof this.token === 'string') && this.token.trim().length > 0) {
            this.verifyToken();
        }
    },
    methods: {
        verifyRedirect(){
            this.$root.verifyAuth();
            this.$router.push({name: "dashboard"});
        },
        verifyToken() {
            this.axios.post(this.endpoint.get('contact_verification_verify'), {
                verification_type_id: 1,
                verification_data: this.token
            }).then(response => {
                this.onResponseSwal(response, () => {
                    this.verifyRedirect();
                }, undefined, true, {
                    text: this.$t('pages.contactVerify.email.responseMessage.success'),
                });
            }).catch((error) => {
                if(this.currentUser.email_verified_at) {
                    this.onResponseFailureSwal(error.response, () => {
                        this.verifyRedirect();
                    },  {
                        icon: "warning",
                        title: this.$t('messages.warning'),
                        text: this.$t('pages.contactVerify.email.responseMessage.emailAlreadyVerified'),
                    });
                } else {
                    this.tokenVerified = false;
                }
            })
        },
    }
}
</script>

<style>
.custom-spinner {
    width: 6rem;
    height: 6rem;
}
</style>